import React from 'react';
import { Routes, Route } from "react-router-dom";
import ADCUSecurityList from "./adcu-security-list/adcu-security-list";
import ADCUSecurityDetail from "./adcu-security-detail/adcu-security-detail";

const ADCUSecurities = () => {
  return (
    <Routes>
      <Route index element={<ADCUSecurityList />} />
      <Route path=":securityId" element={<ADCUSecurityDetail />} />
    </Routes>
  )
}

export default ADCUSecurities;



